import { USER_MANAGE } from '@src/constant'
import { goBack, goto } from '@src/route'
import CommonService from '@src/service/commonService'
import { getItemObj, removeItem } from '@src/util/store'
import { Icon, Modal, NavBar } from 'antd-mobile-v2'
import { NavBarProps } from 'antd-mobile-v2/lib/nav-bar/PropsType'
import './index.scss'

interface INavBarProps extends NavBarProps {
  isBack?: boolean
  title: string
  isRight?: boolean
}

function INavBar(props: INavBarProps) {
  const { userType, storeName } = getItemObj('userInfo')
  const defaultTitle = userType === USER_MANAGE ? '易摩宇' : storeName
  const { title = defaultTitle, isRight = false, isBack = true } = props

  const logout = () => {
    Modal.alert('确认退出登录?', '', [
      { text: '取消' },
      {
        text: '退出',
        onPress: () => {
          CommonService.logout().finally(() => {
            goto('/login')
            removeItem('userInfo')
          })
        },
      },
    ])
  }
  return (
    <NavBar
      className="i-nav-bar-wrapper"
      onLeftClick={() => isBack && goBack()}
      rightContent={
        isRight && (
          <div className="out" onClick={logout}>
            退出
          </div>
        )
      }
      icon={isBack && <Icon type="left" />}
    >
      {title}
    </NavBar>
  )
}

export default INavBar
